import { render, staticRenderFns } from "./area-heatmap.vue?vue&type=template&id=ebcf094c&"
import script from "./area-heatmap.vue?vue&type=script&lang=js&"
export * from "./area-heatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports